module.exports = __webpack_public_path__ + "img/credit_card.94e35f49.svg";